import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" In App ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 테스트 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Open ")

import {AgHeaderS, AgTextS, AgContentS, AgButtonS} from '@/components/ag'
import {IonPage} from '@ionic/vue'
import {useInAppBrowser} from '@/composables'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const inAppBrowser = useInAppBrowser(
    'https://angelleague.io',
    '_black',
    {

    },
)

const isAppOpen = inAppBrowser.isOpen

const onOpenInAppBrowser = () => {
  const uuid = localStorage.getItem('uuid')
  const token = localStorage.getItem('token')
  const user = localStorage.getItem('user')

  inAppBrowser.open(
      undefined,
      true,
      {
    code: `
      window.addEventListener('load', () => {
        localStorage.setItem('uuid', '${uuid}');
        localStorage.setItem('token', '${token}');
        localStorage.setItem('user', '${user}');
      });
    `,
  },
  )
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AgHeaderS), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AgTextS), { css: {typography: 'tit22b'} }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgContentS), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AgTextS), null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_unref(AgTextS), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(isAppOpen)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(AgButtonS), {
            fill: "primary",
            onClick: onOpenInAppBrowser
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})